import { PayAtExternalResponse } from "../../services/api/payment/payment-pay-at-link";
import { RapydEmbeddedResponse } from "../../services/api/payment/payment-rapyd";
import { PaymentAttribution } from "./enums/mc-transaction-types";
import { PayAtRedirectResolution, PayAtRedirectResponse, PaymentRequestPayAt, PaymentRequestRedirectResponse } from "./payment-request-pay-at";
import { EmbeddedIframeResponseResolution } from "./payment-request-rapyd-embedded";
import { PaymentPlatform } from "./payment.store";


export enum PaymentServiceDependency {
  Subscription = 'Subscription',
  Profile = 'Profile',
  Quotes = 'Quotes',
}
export interface PaymentRequestType<T extends PaymentRequestRedirectResponse | PayAtRedirectResponse[] | PayAtExternalResponse | PayAtRedirectResolution | RapydEmbeddedResponse> {
  addValues: (values: any) => void;
  toPaymentRequestObject: () => { [key: string]: number | string | string[] | undefined };
  toTokenRequestObject: () => { [key: string]: number | string | string[] | undefined };
  getDependantValues: () => Promise<PaymentRequestType<T>>;
  handleResponse: (response: T, paymentAttribution?: PaymentAttribution) => Promise<PayAtRedirectResolution>;
}

export class GeneratePaymentRequest {
  request!: PaymentRequestType<any>;

  constructor(platform: PaymentPlatform, initialValues: Partial<any>) {
    switch (platform) {
      case PaymentPlatform.PayAtRedirect:
        this.request = new PaymentRequestPayAt(initialValues);
        break;
    }
  }

  addValues(values: { [key: string]: number | string | undefined }) {
    return this.request.addValues(values);
  }

  buildRequest(tokenize?: boolean) {
    return this.request.getDependantValues()
      .then(request => {
        return tokenize ? request.toTokenRequestObject() : request.toPaymentRequestObject()
      })
  }

  toPaymentRequestObject() {
    return {
      ...this.request.toPaymentRequestObject()
    }
  }
}
